(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pa-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'gc_wishlist_v1';
    function readList () { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function writeList (l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} document.dispatchEvent(new CustomEvent('gc:wishlist-change', { detail: l })); }
    function paint () {
      var list = readList();
      document.querySelectorAll('[data-pa-wish]').forEach(function (b) {
        var id = b.getAttribute('data-pa-wish-id');
        if (list.indexOf(id) >= 0) b.classList.add('is-active');
        else b.classList.remove('is-active');
      });
      var counts = document.querySelectorAll('[data-pa-wish-count]');
      counts.forEach(function (c) { c.textContent = list.length; c.toggleAttribute('hidden', list.length === 0); });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pa-wish]');
      if (!b) return;
      e.preventDefault();
      var id = b.getAttribute('data-pa-wish-id');
      if (!id) return;
      var list = readList();
      var i = list.indexOf(id);
      if (i >= 0) list.splice(i, 1); else list.push(id);
      writeList(list);
      paint();
    });
    document.addEventListener('DOMContentLoaded', paint);
    paint();

    // Quick add
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-pa-quickadd]');
      if (!form) return;
      var needsPick = form.getAttribute('data-pa-needs-pick') === 'true';
      if (needsPick) {
        e.preventDefault();
        var url = form.getAttribute('data-pa-product-url');
        if (url) window.location.href = url;
        return;
      }
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      if (btn) { btn.disabled = true; btn.dataset._t = btn.textContent; btn.textContent = 'Añadiendo…'; }
      fetch(form.action, {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = 'Añadido'; setTimeout(function () { btn.disabled = false; btn.textContent = btn.dataset._t || '+ Añadir al carrito'; }, 1400); }
        document.dispatchEvent(new CustomEvent('gc:cart-add'));
        var drawer = document.querySelector('[data-cart-drawer]');
        if (drawer && typeof drawer.refresh === 'function') drawer.refresh();
        if (drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset._t || '+ Añadir al carrito'; }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
